import { Stack, TableCell, Typography } from "@mui/material";
import React, { useMemo } from "react";
import EditIcon from "@mui/icons-material/Edit";

import { styles } from "./styles";
import { TableCellInput } from "../TableCellInput";
import { formatValue } from "../../../../utils";

export const TableBodyGrowthType = ({
  dimensionItem,
  selectedDimensionsQuantity,
  tableValues,
  onChangeTableValues,
  indicator,
  formatProps,
  isEdit,
  setIsEdit,
}) => {
  const formattedValue = useMemo(() => {
    if (isEdit) {
      return null;
    }
    return Number(tableValues[indicator?.id]?.start_value) || null;
  }, [isEdit, tableValues, formatProps, indicator?.id]);

  const handleEdit = () => {
    setIsEdit(true);
  };
  if (!selectedDimensionsQuantity) {
    return (
      <>
        <TableCell component="th" sx={styles.tableCell}>
          <Typography sx={styles.dimensionName}>{indicator?.name}</Typography>
        </TableCell>

        <TableCell sx={styles.editableTableCell} onClick={handleEdit}>
          <EditIcon />
          <TableCellInput
            name="start_value"
            value={formattedValue}
            onChange={onChangeTableValues(
              indicator,
              selectedDimensionsQuantity
            )}
          />
        </TableCell>

        <TableCell sx={styles.editableTableCell}>
          <EditIcon />
          <TableCellInput
            name="growth_rate"
            value={tableValues[indicator?.id]?.growth_rate}
            onChange={onChangeTableValues(
              indicator,
              selectedDimensionsQuantity
            )}
          />
        </TableCell>
      </>
    );
  }

  return (
    <>
      <TableCell component="th" sx={styles.tableCell}>
        {selectedDimensionsQuantity === 1 ? (
          <Typography sx={styles.dimensionName}>
            {dimensionItem?.name}
          </Typography>
        ) : (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            {dimensionItem?.map((item) => (
              <Typography key={item} sx={styles.dimensionName}>
                {item}
              </Typography>
            ))}
          </Stack>
        )}
      </TableCell>

      <TableCell sx={styles.editableTableCell}>
        <EditIcon />
        <TableCellInput
          name="start_value"
          value={
            selectedDimensionsQuantity === 1
              ? tableValues[dimensionItem?.name]?.start_value
              : tableValues[dimensionItem?.join("-")]?.start_value
          }
          onChange={onChangeTableValues(
            dimensionItem,
            selectedDimensionsQuantity
          )}
        />
      </TableCell>

      <TableCell sx={styles.editableTableCell}>
        <EditIcon />
        <TableCellInput
          name="growth_rate"
          value={
            selectedDimensionsQuantity === 1
              ? tableValues[dimensionItem?.name]?.growth_rate
              : tableValues[dimensionItem?.join("-")]?.growth_rate
          }
          onChange={onChangeTableValues(
            dimensionItem,
            selectedDimensionsQuantity
          )}
        />
      </TableCell>
    </>
  );
};
